import React, {useRef, useState} from 'react'
import ReactMarkdown from 'react-markdown'
import Money from '@components/fields/Money'
import Button from '@components/V3/Button'
import Label from '@components/V3/forms/Label'
import Modal from '@components/V3/Modal'
import {useTranslation} from 'next-i18next'
import {Field, Form} from 'simple-react-form'

import useSetTipAmount from './FixedTip/useSetTipAmount'
import Selector from './Selector'
import useOnSubmitHandlers from './useOnSubmitHandlers'

export default function CustomTip({selected = false}: {selected?: boolean}) {
  const {t} = useTranslation('checkoutv3', {keyPrefix: 'payment.tip'})
  const {t: tGeneric} = useTranslation('generic')
  const setTipAmount = useSetTipAmount()
  const [modalOpen, setModalOpen] = useState(false)
  const [tip, setTip] = useState(null)
  const fieldRef = useRef(null)
  const buttonRef = useRef(null)
  const [placeholder, setPlaceholder] = useState<string>(t('customTip.exampleFixedTip'))

  const {onSuccess, onError, isSubmitting, onSubmit} = useOnSubmitHandlers()

  const submit = () => {
    onSubmit()
    const amount = Math.max(tip ? tip : 0, 0)

    setTipAmount({
      amount,
      onError,
      onSuccess: () => {
        onSuccess()
        setModalOpen(false)
      }
    })
  }

  return (
    <>
      <Selector
        selected={selected}
        onClick={() => setModalOpen(true)}
        bottom={t('otherAmount')}
        top=""
      />
      <Modal
        forceJustoFont
        header={t('header')}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        initialFocusRef={fieldRef}>
        <p className="text-sm mt-4">
          <ReactMarkdown>{t('customTip.description')}</ReactMarkdown>
        </p>
        <Form onSubmit={() => buttonRef.current?.click()}>
          <Field
            type={Money}
            passProps={{
              onBlur: () => setPlaceholder(t('customTip.exampleFixedTip')),
              onFocus: () => setPlaceholder(''),
              ref: fieldRef
            }}
            label={<Label className="mb-[-4px]">{t('customTip.amount')}</Label>}
            placeholder={placeholder}
            fieldName="amount"
            value={tip}
            onChange={value => setTip(value)}
          />
          <p className="text-sm text-gray-400 mb-4">{t('customTip.subtitle')}</p>
          <Button
            ref={buttonRef}
            disabled={isSubmitting || tip === null || tip === ''}
            loading={isSubmitting}
            big
            full
            primary
            onClick={submit}>
            {isSubmitting ? null : tGeneric('fields.save', {ns: 'generic'})}
          </Button>
        </Form>
      </Modal>
    </>
  )
}
